import { SharedProps } from '@/types'
import { usePage } from '@inertiajs/react'
import { useEffect } from 'react'
import { toast } from 'react-hot-toast'

export default function FlashMessages() {
  const page = usePage<SharedProps>()
  const { notice, alert } = page.props.flash

  useEffect(() => {
    if (notice) toast.success(notice, { id: notice })
    if (alert) toast.error(alert, { id: alert })
  }, [page])

  return null
}
